var swiper = new Swiper(".custom-scolslider", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var swiper = new Swiper(".vertical-swiper", {
  autoHeight: false, // disable unless you're sure
  freeMode: false,
  navigation: {
    nextEl: ".swiper-button-nexts",
    prevEl: ".swiper-button-prevs",
  },
  breakpoints: {
    768: {
      direction: 'vertical',
      loop: false
    }
  }
});
